import { render, staticRenderFns } from "./OrderVase.vue?vue&type=template&id=3ab2c21d&"
import script from "./OrderVase.vue?vue&type=script&lang=js&"
export * from "./OrderVase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports